export default (id, goal) => {
    const _tmr = window._tmr || (window._tmr = []);
    _tmr.push({
        type: 'reachGoal',
        id: id,
        goal: goal,
    });
    return true;
};